/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

export const authCustomerState = {
    authenticated: false,
    user: undefined,
};
